window.getCookie = function(name) {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith(name + '=')) {
      return cookie.substring(name.length + 1);
    }
  }
  return null;
}

window.setCookie = function(cookieName, cookieValue) {
  // Calculate the expiration date for the cookie (in this example, it will expire in 1 year)
  var expirationDate = new Date();
  expirationDate.setFullYear(expirationDate.getFullYear() + 1);
  
  // Create the cookie string with the name, value, expiration date, and path
  var cookieString = cookieName + "=" + encodeURIComponent(cookieValue) + "; expires=" + expirationDate.toUTCString() + "; path=/";
  
  // Set the cookie using the cookie string
  document.cookie = cookieString;
}
